import * as parts from './parts'

export interface FaxColors {
  ListView: parts.FaxListViewColors
  NewFaxForm: parts.NewFaxFormColors
  NewFaxLoadingView: parts.NewFaxLoadingViewColors
}

export const faxColors: FaxColors = {
  ListView: parts.faxListViewColors,
  NewFaxForm: parts.newFaxFormColors,
  NewFaxLoadingView: parts.newFaxLoadingViewColors,
}
